export const metaInfo = {
  name: "sample-app",
  version: "5.0.1",
  type: "sample",
  platform: "React",
};
